<template>
  <div class="grid">
	<template v-if="loader==true">
		<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em" />
		</div>
	</template>
    <div class="field col-12">
		<Accordion>
			<template v-for="(evento,index) in list_eventos" :key="index">
			<AccordionTab>

				<template v-slot:header>
					<div class="flex">
						<i class="pi pi-map-marker fs-xlarge mr-3 pink-color my-5"></i>
							<div class="field formgrid grid p-fluid">
								<div class="col-12 lg:col-3">
									<p><strong>Origen: </strong><br>{{evento.origin}}<br>
									{{evento.origin_county}}</p>
								</div>
								<div class="col-12 lg:col-3">
									<p><strong>Destino: </strong><br>{{evento.destination}}<br>
									{{evento.destination_county}}</p>
								</div>
								<div class="col-6 lg:col-3">
									<p><strong>Carga: </strong><br>{{evento.product}}<br>
									{{new Intl.NumberFormat().format(evento.weight)}}Kg</p>
								</div>
								<div class="col-6 lg:col-3">
									<p><strong>Generador: </strong><br>{{evento.client_name}}<br>
									{{evento.client_id}}</p>
								</div>
							</div>
					</div>
				</template>
                <div class="formgrid grid p-fluid">
					<div class="field col-12 text-center">
                        <template v-if="code_seway==1">
                            <img src="layout/images/widgets/feature-faq.svg" alt="feature-faq" class="mb-2 mt-3">
                            <h4>No se encuentran eventos en seway</h4>
                        </template>
                        <template v-if="code_seway==0">
                            <img src="layout/images/widgets/feature-faq.svg" alt="feature-faq" class="mb-2 mt-3">
                            <h4>No se pudo buscar los eventos</h4>
                        </template>
                        <div style="margin-top: 1em">
                            <transition-group name="dynamic-box" tag="div" class="grid">
                                <div v-for="(col,index) in evento.events" :key="index" class="col">
                                    <div class="box">
                                    
                                    <p class="step_mov"><strong>
                                            <template v-if="col.id_events==2">
                                                <i class="pi pi-truck pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Llegada de Carga
                                            </template>
                                            <template v-if="col.id_events==3">
                                                <i class="pi pi-box pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Inicio de Carga
                                            </template>
                                            <template v-if="col.id_events==4">
                                                <i class="pi pi-box pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Fin de Carga
                                            </template>
                                            <template v-if="col.id_events==5">
                                                <i class="pi pi-check-circle pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Carga aceptada
                                            </template>
                                            <template v-if="col.id_events==6">
                                                <i class="pi pi-building pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Llegada a sitio Descargue
                                            </template>
                                            <template v-if="col.id_events==7">
                                                <i class="pi pi-check-circle pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Inicio Descargue
                                            </template>
                                            <template v-if="col.id_events==8">
                                                <i class="pi pi-check-circle pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Fin Descargue
                                            </template>
                                            <template v-if="col.id_events==9">
                                                <i class="pi pi-truck pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Descarga Aceptada
                                            </template>
                                            <template v-if="col.id_events==10">
                                                <i class="pi pi-exclamation-triangle pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Entrega Pendiente
                                            </template>
                                            <template v-if="col.id_events==11">
                                                <i class="pi pi-verified pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Entrega Exitosa
                                            </template>
                                            <template v-if="col.id_events==12">
                                                <i class="pi pi-times-circle pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Entrega Rechazada
                                            </template>
                                            <template v-if="col.id_events==13">
                                                <i class="pi pi-map-marker pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Planta de carga reservada
                                            </template>
                                            <template v-if="col.id_events==14">
                                                <i class="pi pi-building pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Inicio de carga en planta
                                            </template>
                                            <template v-if="col.id_events==15">
                                                <i class="pi pi-building pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Fin de carga en planta
                                            </template>
                                            <template v-if="col.id_events==16">
                                                <i class="pi pi-building pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Inicio de descarga en planta
                                            </template>
                                            <template v-if="col.id_events==17">
                                                <i class="pi pi-building pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Fin de descarga en planta
                                            </template>
                                            <template v-if="col.id_events==18">
                                                <i class="pi pi-map-marker pink-color mb-2" style="font-size: 3rem"></i><br>
                                                Descargada en planta no reservada
                                            </template>
                                        </strong></p>
                                        <p>{{col.created_at}}</p>
                                        <template v-if="col.latitude && col.longitude">
                                        <a :href="'https://www.google.com.co/maps?q='+col.latitude+','+col.longitude" target="_blank">Ver en Mapa</a>
                                        </template>
                                        <br>
                                        <template v-if="col.image_event.length > 0">
                                        <Button icon="pi pi-eye" @click="openGaleriaEventos(col.image_event)" :loading="loader" class="p-button-rounded p-button-primary mt-2"/>
                                        <Galleria :value="img_eventos" :responsiveOptions="galleriaResponsiveOptions" :numVisible="3" containerStyle="max-width: 50%"
                                            :circular="true" :fullScreen="true" :showItemNavigators="true" v-model:visible="show_galeria_evnets">
                                            <template #item="slotProps">
                                                <img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width: 60%; display: block;" />
                                            </template>
                                        </Galleria>
                            </template>
                            
                                </div>
                            </div>
                        </transition-group>
                        </div>
                    </div>
                        </div>
			</AccordionTab>
			</template>
		</Accordion>
		

	</div>
	<Dialog v-model:visible="modalVisible" header="Detalle de Temperatura" :modal="true">
		<p><strong>Fecha:</strong> {{ selectedData.fecha }}</p>
		<p><strong>Temperatura:</strong> {{ selectedData.temperatura }}°C</p>
	</Dialog>
  </div>
</template>

<script>
import { APIENDPOINTIMG } from '../../../app.config'
export default {
	data() {
		return {
			message: [],
			info_detalle_mov: [],
			customers: [],
            img_eventos: [],
			detalle_reme: [],
			details_remesa: [],
			code_seway: '',
			code_cumplido: '',
			sinimagen: [],
			list_cumplidos: [],
			list_sucursales: [],
			loader: false,
            show_galeria_evnets: false,
			modalVisible: false,
			selectedData: { fecha: "", temperatura: "" },
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
			chartData: {},
			chartOptions: {
				responsive: true,
				width: 400, // Define el ancho deseado para la gráfica
				height: 200, // Define el alto deseado para la gráfica
				scales: {
					y: {
						beginAtZero: true
					}
				}
			},
			loading: false,
			promedio_temperatura: 0,
			temperatua_max: 0,
			temperatua_min: 0,
		}
	},
	props: {
        list_eventos: Array,
        code_seway: String,
        Customer: Array
    },
  	mounted(){
		this.sinimagen = APIENDPOINTIMG+'img_profiles/profile.jpg';
		if (this.temperaturas_sigueme?.viaje?.temperaturas) {
			this.chartData = this.getchartData(this.temperaturas_sigueme.viaje.temperaturas);
		}
	},
	watch: {
		temperaturas_sigueme: {
			deep: true,  // Detecta cambios dentro del objeto
			handler(newValue) {
				if (newValue?.viaje?.temperaturas) {
					this.chartData = this.getchartData(newValue.viaje.temperaturas);
				}
			}
		}
	},
	methods:{
		openGaleriaEventos(imagenes) {
			console.log(imagenes);
			this.img_eventos = [];

			var _that = this;
			this.loader = true;
			var nombre_campo_img = 'image_url';
			var url = 'img_public';
			window.api.call('post', url, {imagenes: imagenes,nombre_campo_img: nombre_campo_img}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.img_eventos = response.data.data.images;
					_that.show_galeria_evnets = true;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		}
	}
};
</script>